<div class="card-dotted-line-component d-inline-flex">
  <div class="card-dotted-line-component-content">
    <ng-content></ng-content>
  </div>
</div>
